import { API_BASE_URL } from "../../../config";
import { apiFetch, downloadFile } from "../../../utils/api";

export const fetchOrders = (authToken) =>
  apiFetch(`${API_BASE_URL}/api/orders/`, { token: authToken });

export const deleteOrderRequest = (orderId, authToken) =>
  apiFetch(`${API_BASE_URL}/api/orders/${orderId}/`, authToken, { method: "DELETE" });

export const downloadOrdersCsv = (authToken) =>
  downloadFile(`${API_BASE_URL}/api/orders/download-csv/`, authToken, "orders.csv");

export const uploadOrdersCsv = async ({ file, authToken, authScheme }) => {
  const form = new FormData();
  form.append("file", file);
  const response = await fetch(`${API_BASE_URL}/api/orders/upload-csv/`, {
    method: "POST",
    headers: { Authorization: `${authScheme} ${authToken}` },
    body: form,
  });
  const bodyText = await response.text();
  let data = null;
  try {
    data = bodyText ? JSON.parse(bodyText) : null;
  } catch {
    data = null;
  }
  if (!response.ok) {
    const detail = data?.detail || data?.error || bodyText || `HTTP ${response.status}`;
    throw new Error(detail);
  }
  return data;
};
